// API Configuration for different environments
const config = {
  development: {
    apiBaseUrl: '/api',
    appUrl: 'http://localhost:3000'
  },
  production: {
    apiBaseUrl: 'https://oilbuddy.ai/api',
    appUrl: 'https://oilbuddy.ai'
  }
}

// Determine current environment
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost'
const environment = isDevelopment ? 'development' : 'production'

// Export current configuration
export const API_BASE_URL = config[environment].apiBaseUrl
export const APP_URL = config[environment].appUrl

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  const url = `${API_BASE_URL}/${endpoint.replace(/^\//, '')}`
  console.log('buildApiUrl called:', { endpoint, url, environment, API_BASE_URL })
  return url
}

// Environment info
export const ENV_INFO = {
  isDevelopment,
  environment,
  hostname: window.location.hostname
}
